import { cva } from 'class-variance-authority';

export const tabsTriggerVariants = cva(
  'inline-flex items-center whitespace-nowrap text-sm transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        pill: 'justify-center rounded-md px-3 py-1 text-sm font-medium ring-offset-background focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow',
        underline:
          'relative -mb-px justify-center rounded-none border-b-2 border-transparent px-4 pb-3 pt-2 font-normal focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset data-[state=active]:z-10 data-[state=active]:border-primary data-[state=active]:font-medium data-[state=active]:shadow-none'
      }
    },
    defaultVariants: {
      variant: 'pill'
    }
  }
);
